import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgArrowViewDetail({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#E3E8E8" cx={12} cy={12} r={10} />
        <path
          d="M15.84 12.33l-4.4 4.4a.54.54 0 01-.77 0l-.51-.52a.54.54 0 010-.76l3.49-3.5-3.5-3.51a.54.54 0 010-.77l.52-.51a.54.54 0 01.77 0l4.4 4.4c.21.21.21.56 0 .77z"
          fill="#666"
        />
      </g>
    </svg>
  );
}

SvgArrowViewDetail.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgArrowViewDetail.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgArrowViewDetail svgRef={ref} {...props} />);
export default ForwardRef;
